export { default } from "@vendors/CreativeTim/components/Card/CardIcon.js";
